/**
 * Mainbeauty — mở khoá SĐT/email đã che, chỉ sau thao tác đầu của người dùng.
 */

const KEY = "pRo1nV#2o26"; // khớp PI_CONTACT_KEY trong inc/mainbt-contact.php
const SELECTOR = "[data-pi-cloak]";

// pointerdown/focusin chạy TRƯỚC click nên bấm hay tab thẳng vào link vẫn ra số thật.
const TRIGGERS = [
  "pointerdown",
  "pointermove",
  "touchstart",
  "keydown",
  "wheel",
  "scroll",
  "focusin",
];

function unpack(packed) {
  const raw = window.atob(packed.split("").reverse().join(""));
  let out = "";

  for (let i = 0; i < raw.length; i++) {
    out += String.fromCharCode(
      raw.charCodeAt(i) ^ KEY.charCodeAt(i % KEY.length)
    );
  }

  return out;
}

function reveal(el) {
  let data;

  try {
    data = JSON.parse(unpack(el.getAttribute("data-pi-cloak")));
  } catch (e) {
    return; // gói hỏng: giữ bản che + href dự phòng, đừng làm vỡ trang
  }

  if (data.h) el.setAttribute("href", data.h);
  if (data.t) el.textContent = data.t;

  el.removeAttribute("data-pi-cloak");
  el.removeAttribute("aria-label");
  el.classList.remove("pi-cloak");
}

function revealAll() {
  document.querySelectorAll(SELECTOR).forEach(reveal);
}

TRIGGERS.forEach((type) =>
  document.addEventListener(type, revealAll, {
    once: true,
    passive: true,
    capture: true,
  })
);
